import { useState, useEffect } from 'react';

export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm shadow-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-emerald-500 rounded-full flex-shrink-0">
              <i className="ri-stethoscope-line text-lg sm:text-xl text-white"></i>
            </div>
            <span className="text-base sm:text-xl font-bold text-slate-900">Dr. Arash Yousefi</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <a
              href="#hero"
              className="text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer text-sm lg:text-base"
            >
              Home
            </a>
            <a
              href="#about"
              className="text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer text-sm lg:text-base"
            >
              About
            </a>
            <a
              href="#services"
              className="text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer text-sm lg:text-base"
            >
              Services
            </a>
            <a
              href="#locations"
              className="text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer text-sm lg:text-base"
            >
              Locations
            </a>
            <a
              href="#contact"
              className="bg-emerald-500 text-white px-5 lg:px-6 py-2 lg:py-2.5 rounded-full font-semibold hover:bg-emerald-400 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer text-sm lg:text-base"
            >
              Contact Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-slate-700 hover:text-emerald-600 transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3 border-t border-slate-200 pt-4">
            <a
              href="#hero"
              onClick={handleLinkClick}
              className="block text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer py-2"
            >
              Home
            </a>
            <a
              href="#about"
              onClick={handleLinkClick}
              className="block text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer py-2"
            >
              About
            </a>
            <a
              href="#services"
              onClick={handleLinkClick}
              className="block text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer py-2"
            >
              Services
            </a>
            <a
              href="#locations"
              onClick={handleLinkClick}
              className="block text-slate-700 hover:text-emerald-600 transition-colors font-medium cursor-pointer py-2"
            >
              Locations
            </a>
            <a
              href="#contact"
              onClick={handleLinkClick}
              className="block bg-emerald-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-emerald-400 transition-all duration-300 shadow-md text-center cursor-pointer"
            >
              Contact Us
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
